export const search = (value, list) => {
  let has = false;

  list.forEach((item) => {
    if (item === value) {
      has = true;
    }
  });
  return has;
}